import React, {useEffect} from "react";
import {Tree} from "antd";
import {useModel} from "../../../models";


export default function () {
    const [{materialSortDict}, {getMaterialSortDict}] = useModel("cmDict");
    const [{selectedTypeNode}, {setSelectedTypeNode}] = useModel("material");
    // const onSelect = (selectedKeys, info) => {
    //     //获取父节点
    //     const selectedNode = info.selectedNodes[0]
    // };
    const onSelect = (selectedKeys, info) => {
        if (info.selectedNodes && info.selectedNodes.length > 0&&info.selected==true) {
            //获取父节点
            const selectedNode = info.selectedNodes[0];
            console.log(selectedNode)
            setSelectedTypeNode(selectedNode);
        }else{
            setSelectedTypeNode(null);
        }
    };
    useEffect(() => {
        getMaterialSortDict();
    }, [])
    return (
        <Tree
            // defaultExpandAll
            // defaultExpandAll
            // defaultExpandedKeys={['0-0-0']}
            onSelect={onSelect}
            treeData={materialSortDict}
            style={{height: "100%"}}
        />
    );

};